<template>
    <div v-route-title="data?('企业'+data.type+'风险事件详情'):'企业风险事件详情'">
        <div class="yq-penalty-details" v-if="data">
            <div class="yq-penalty-title">企业{{data.type}}风险事件详情</div>
            <table class="yq-penalty-table" v-if="data.type==='工商变更'">
                <tr>
                    <td class="yq-penalty-table-head" width="100">公司名称</td>
                    <td class="yq-penalty-table-value">
                        <el-link type="primary" @click="openCompanyPage(data.companyId)">{{data.companyName}}</el-link>
                    </td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">变更事项</td>
                    <td class="yq-penalty-table-value">{{data.summary.changeMatter}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">变更前内容</td>
                    <td class="yq-penalty-table-value">{{data.summary.changeBefore}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">变更后内容</td>
                    <td class="yq-penalty-table-value">{{data.summary.changeAfter}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">变更时间</td>
                    <td class="yq-penalty-table-value">{{data.publishDate}}</td>
                </tr>
            </table>
            <table class="yq-penalty-table" v-if="data.type==='裁判文书'">
                <tr>
                    <td class="yq-penalty-table-head" width="100">公司名称</td>
                    <td class="yq-penalty-table-value">
                        <el-link type="primary" @click="openCompanyPage(data.companyId)">{{data.companyName}}</el-link>
                    </td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">文书名</td>
                    <td class="yq-penalty-table-value">{{data.summary.wenshuming}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">文书号</td>
                    <td class="yq-penalty-table-value">{{data.summary.wenshuhao}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">案件类型</td>
                    <td class="yq-penalty-table-value">{{data.summary.type}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">所在城市</td>
                    <td class="yq-penalty-table-value">{{data.summary.city}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">公告日期</td>
                    <td class="yq-penalty-table-value">{{data.publishDate}}</td>
                </tr>
            </table>
            <table class="yq-penalty-table" v-if="data.type==='开庭公告'">
                <tr>
                    <td class="yq-penalty-table-head" width="100">公司名称</td>
                    <td class="yq-penalty-table-value">
                        <el-link type="primary" @click="openCompanyPage(data.companyId)">{{data.companyName}}</el-link>
                    </td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">法院名称</td>
                    <td class="yq-penalty-table-value">{{data.summary.courtName}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">公告标题</td>
                    <td class="yq-penalty-table-value">{{data.summary.title}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">公告日期</td>
                    <td class="yq-penalty-table-value">{{data.publishDate}}</td>
                </tr>
            </table>
            <table class="yq-penalty-table" v-if="data.type==='失信人'">
                <tr>
                    <td class="yq-penalty-table-head" width="100">公司名称</td>
                    <td class="yq-penalty-table-value">
                        <el-link type="primary" @click="openCompanyPage(data.companyId)">{{data.companyName}}</el-link>
                    </td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">案号</td>
                    <td class="yq-penalty-table-value">{{data.summary.caseCode}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">履行状态</td>
                    <td class="yq-penalty-table-value">{{data.summary.performance}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">执行依据</td>
                    <td class="yq-penalty-table-value">{{data.summary.gistCid}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">执行法院</td>
                    <td class="yq-penalty-table-value">{{data.summary.courtName}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">公告日期</td>
                    <td class="yq-penalty-table-value">{{data.publishDate}}</td>
                </tr>
            </table>
            <table class="yq-penalty-table" v-if="data.type==='资产负债率过高'">
                <tr>
                    <td class="yq-penalty-table-head" width="100">公司名称</td>
                    <td class="yq-penalty-table-value">
                        <el-link type="primary" @click="openCompanyPage(data.companyId)">{{data.companyName}}</el-link>
                    </td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">资产负债率</td>
                    <td class="yq-penalty-table-value">{{data.summary.zcfzl}}</td>
                </tr>
                <tr>
                    <td class="yq-penalty-table-head" width="100">公告日期</td>
                    <td class="yq-penalty-table-value">{{data.publishDate}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import companyMonitorService from '../service/company_monitor'

    export default {
        name: "CompanyRiskEvent",
        props: {
            id: String
        },
        data(){
            return {
                data: null
            }
        },
        created(){
            companyMonitorService.listCompanyRiskEvents({id: this.id}).then(response=>{
                this.data = response.data.data.content[0]
            })
        },
        methods: {
            openCompanyPage(id){
                companyMonitorService.openCompanyPage(id)
            }
        }
    }
</script>

<style scoped>

</style>
